<template>
  <div>
    <el-dialog title="管理通知人" :visible.sync="notifierShow" width="960px">
      <el-button type="primary" size="small" style="margin-top: 10px;margin-bottom: 8px;" @click="getbmcwx">新增通知人</el-button>

      <div style="height: 574px;overflow: auto;">
        <!-- 表格 -->
        <el-table
         :data="tableData"
         style="width: 100%">
         <el-table-column label="序号" type="index"></el-table-column>
         <el-table-column label="微信" prop="nickname">
           <template slot-scope="scope">
             <span>
               <img :src="scope.row.headimgurl" style="width: 40px;vertical-align: middle;margin-right: 10px;">
               {{scope.row.nickname}}
             </span>
           </template>
         </el-table-column>
         <el-table-column label="备注">
           <template slot-scope="scope">
             <span v-if="deleteShow[scope.$index]">
               {{scope.row.remark || '--'}}
             </span>
             <span>
               <el-input
                v-model="remarkInput[scope.$index]"
                placeholder="请输入"
                size="small"
                v-if="saveShow[scope.$index]"
                clearable>
              </el-input>
             </span>
           </template>
         </el-table-column>
         <el-table-column label="操作">
           <template slot-scope="scope">
             <el-button type="text" @click="save(scope.$index,scope.row.id)" v-if="saveShow[scope.$index]">保存</el-button>
             <el-button type="text" @click="cancel(scope.$index)" v-if="saveShow[scope.$index]">取消</el-button>
             <el-button type="text" @click="note(scope.$index,scope.row.remark)" v-if="deleteShow[scope.$index]">备注</el-button>
             <!-- <el-popover placement="top" v-model="wxShow[scope.$index]">
               <span><i class="el-icon-warning" style="color: #ffaa16;margin-top: 10px;"></i></span>
               <span style="margin-left: 9px;color: #585858;font-weight: bold;">你确定要删除该微信吗？</span>
               <div style="text-align: right; margin-top: 15px;">
                 <el-button type="primary" size="small" style="margin-left: 5px;" @click="wxSure(scope.$index)">确 定</el-button>
                 <el-button size="small" type="TheCustom" @click="wxCancel(scope.$index)">取 消</el-button>
               </div>
             </el-popover> -->
             <!-- <el-button type="text" @click="deletion(scope.$index,scope.row.id)" v-show="deleteShow[scope.$index]" slot="reference" style="padding-left: 12px;">删除</el-button> -->
             <el-button type="text" @click="deletion(scope.$index,scope.row.id)" v-show="deleteShow[scope.$index]" style="padding-left: 12px;">删除</el-button>
           </template>
         </el-table-column>
       </el-table>
       <div v-show="this.tableData.length >= 1">
         <pagination
           :currentPage="currentPage" :pageSizes="[10, 20, 50, 100]"
           :total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
         </pagination>
       </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="notifierShow = false" size="small" type="TheCustom" style="margin-top: 30px;">关闭</el-button>
      </div>
    </el-dialog>
    <wxBindingComponent ref="childWxBinding"/>
  </div>
</template>

<script>
  import pagination from "../../../components/dataTable/pagination";
  import { mapActions } from 'vuex';
  import wxBindingComponent from "../../../components/wxComponent/wxBindingComponent.vue";
  export default {
    name: 'administrativeNotifier',
    data() {
      return {
        newId: '',
        bid: '',
        wechatUrl: '',
        saveShow: [],
        deleteShow: [],
        wxShow: [],
        remarkInput: [],
        pageNo: 1,
        currentPage: 1,
        pageSize: 10,
        totalNum: 10,
        notifierShow: false,
        tableData: []
      }
    },
    mounted() {
      this.monitorNoticeList()

    },
    methods: {
      theTrigger() {
        this.notifierShow = true
      },
      // 数据源
      monitorNoticeList() {
        let params={
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }
        fetch({
          url: "hcm/hcmNewMonitorProduct/monitorNoticeList",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.tableData = res.data
            this.deleteShow = []
            this.saveShow = []
            this.wxShow = []
            for (let i in this.tableData) {
              this.deleteShow.push(true)
              this.saveShow.push(false)
              this.wxShow.push(false)
            }
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 获取bid调用微信接口
      getbmcwx() {
        fetch({
          url: "hcm/userout/getbmcwx",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.bid = data.data.bid
            this.addWechatPerson()
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      //调用微信接口
      addWechatPerson() {
        this.$refs.childWxBinding.getbmcwx('m',this.bid)
  		},
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = `${val}`
        this.childData()
      },
      // 翻页
      handleSizeChange(val) {
        this.pageSize = `${val}`
        this.childData()
      },
      // 编辑
      note(index,remark) {
        this.$set(this.saveShow,index,true);
        this.$set(this.deleteShow,index,false);
        this.remarkInput[index] = remark
      },
      // 删除
      deletion(index,id) {
        this.$set(this.wxShow,index,true);
        this.newId = id
        console.log(this.newId)
        this.wxSure(index)
      },
      // 保存
      save(index,id) {
        let params={
          id: id,
          remark: this.remarkInput[index],
        }
        fetch({
          url: "hcm/hcmNewMonitorProduct/setUpMonitorRemark",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.$message({
              message: res.data,
              type: 'success'
            });
            this.$set(this.saveShow,index,false);
            this.$set(this.deleteShow,index,true);
            this.monitorNoticeList()
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 取消
      cancel(index) {
        this.$set(this.saveShow,index,false);
        this.$set(this.deleteShow,index,true);
      },
      wxSure(index) {
        let params={
          id: this.newId,
        }
        fetch({
          url: "hcm/hcmNewMonitorProduct/deleteMonitorNoticeList",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.$message({
              message: res.data,
              type: 'success'
            });
            this.$set(this.wxShow,index,false);
            this.monitorNoticeList()
          } else {
            this.$set(this.wxShow,index,false);
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      wxCancel(index) {
        this.$set(this.wxShow,index,false);
      },

    },
    components: {
      pagination,
      wxBindingComponent
    }
  }
</script>
<style lang="scss">
  #administrativeNotifier{
    .el-table__empty-text {
      padding-top: 100px;
      background: url("../../../assets/img/other/nodata.svg") no-repeat;
      background-position: center 66px;
    }
    .el-table th {
      background-color: #f2f6fe !important;
      color: #4a4b4c;
    }
    .el-button--TheCustom {
      color: #666;
      border-color: #D9D9D9;
      background-color: #fff;
    }
    .el-button--TheCustom:hover  {
      color: #666;
      border-color: #ded2b8;
      background-color: #faf9f5;
    }
  }
  // @import "style/activityDeclaration.scss";
</style>
